import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useRegisterSW } from "virtual:pwa-register/react";

export default function PwaPrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) {
        setInterval(() => r.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 rounded-lg border bg-background shadow-lg">
      <span className="text-sm">{t("pwa.newVersion")}</span>
      <Button size="sm" onClick={() => updateServiceWorker(true)}>
        {t("pwa.update")}
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        {t("pwa.dismiss")}
      </Button>
    </div>
  );
}
